var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-end"},[_c('GmapAutocomplete',{staticClass:"mx-2 inputMap",staticStyle:{"width":"100%"},on:{"place_changed":_vm.setPlace}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }